module.exports = __webpack_public_path__ + "img/EcodeArea.91b42dde.png";